const GEO_KEY = "dx-geo";
const COUNTRY_KEY = "dx-country";
const DEFAULT = { country_code: "GH", country_name: "Ghana", currency: "GHS", rate: 1, methods: ["MTN MoMo", "Telecel Cash", "AirtelTigo Money"], countries: [] };

let geo = (() => { try { return JSON.parse(localStorage.getItem(GEO_KEY)) || DEFAULT; } catch { return DEFAULT; } })();

export const getGeo = () => geo;
export const savedCountry = () => localStorage.getItem(COUNTRY_KEY) || "";
export const applyGeo = (g) => { geo = g; localStorage.setItem(GEO_KEY, JSON.stringify(g)); };
export const chooseCountry = (code) => { localStorage.setItem(COUNTRY_KEY, code); localStorage.removeItem(GEO_KEY); window.location.reload(); };

const nice = (v) => (v < 100 ? Math.round(v) : v < 1000 ? Math.round(v / 5) * 5 : Number(v.toPrecision(2)));

export const ghsOnly = (n) => `GH₵${Number(n || 0).toLocaleString("en-GH")}`;
export const localAmount = (n) => (geo.currency === "GHS" ? Number(n || 0) : nice(Number(n || 0) * geo.rate));
export const money = (n) => {
  if (geo.currency === "GHS") return ghsOnly(n);
  try {
    return new Intl.NumberFormat(`en-${geo.country_code}`, { style: "currency", currency: geo.currency, currencyDisplay: "narrowSymbol", maximumFractionDigits: 0 }).format(localAmount(n));
  } catch {
    return `${geo.currency} ${localAmount(n).toLocaleString()}`;
  }
};
export const isLocal = () => geo.currency !== "GHS";
